export default {"src":"/_next/static/media/credit_account.b50e4621.svg","height":40,"width":40};